import { IconButton } from '@calendly/ui/components/icon-button';
import { UiIcon } from '@calendly/ui/components/ui-icon';
const appBarCss = "a10cxdqu";
const appBarLeftCss = "a1ykrgyq";
const appBarRightCss = "aazmhra";
const hamburgerCss = "h166j71i";
const AppBarLeft = () => <div className={appBarLeftCss}>
    <IconButton className={hamburgerCss} title="Open navigation">
      <UiIcon name="bolt" size="medium" />
    </IconButton>
  </div>;

// Placeholder — right-side actions (avatar, notifications, etc.) to be implemented
const AppBarRight = () => <div className={appBarRightCss}>App Bar</div>;

/**
 * Top chrome bar rendered in the `app-bar` grid area of `AppShell`.
 * Currently a placeholder — left side shows a mobile hamburger, right side is reserved for
 * avatar, notifications, and other global actions.
 */
export const AppBar = () => <div className={appBarCss}>
    <AppBarLeft />
    <AppBarRight />
  </div>;

require("./AppBar.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppBar.tsx");